module.exports = __webpack_public_path__ + "images/peugeotf0f1b9be52fd59d4d1879b1a5890754b.png";